module.exports = __webpack_public_path__ + "img/certificate-2.65a49e5a.jpg";